import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AjustaTamanhoCampoHelper {
  constructor() {}

  ajustaTamanhoCampo(valor: string | undefined | null, qtdCaracteres: number): string {
    if (!valor) {
      return ''; 
    }

    if (valor.length >= 30) {
      return `${valor.slice(0, qtdCaracteres)}...`;
    } else {
      return valor;
    }
  }
}
